import React, { FC, useCallback, useState } from 'react';
import { useConnect } from './connect';
import FormChangeEmail from './FormChangeEmail';
import { handleChangeEmailFormSubmitted, handleDeleteAccount } from './logic';
import {
  CloseAccountContainter,
  CloseButton,
  Container,
  EmailNotificationsContainer,
  NotificationDescription,
  NotificationHeader,
  NotificationTitle,
  Paragraph,
  StyledToggle,
  TextContainer,
  Title,
} from './styles';
import { Props } from './types';

const ChangeAccount: FC<Props> = () => {
  const {
    editProfile,
    editSettings,
    openConfirmation,
    settings,
  } = useConnect();
  const [isTogglingNotifications, setIsTogglingNotifications] = useState(false);

  const onFormChangeEmailSubmitted = useCallback(
    handleChangeEmailFormSubmitted({ editProfile }),
    [editProfile],
  );

  const onDeleteAccount = useCallback(
    handleDeleteAccount({
      openConfirmation,
    }),
    [openConfirmation],
  );

  const handleEmailNotificationsToggle = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.checked;
      setIsTogglingNotifications(true);
      editSettings({
        enabled: newValue,
      });
      // Reset the toggling state after a short delay
      setTimeout(() => setIsTogglingNotifications(false), 500);
    },
    [editSettings],
  );

  return (
    <Container>
      <Title>Change email</Title>
      <FormChangeEmail onSubmit={onFormChangeEmailSubmitted} />
      <EmailNotificationsContainer>
        <NotificationHeader>
          <NotificationTitle>Receive email notifications</NotificationTitle>
          <StyledToggle
            checked={settings.enabled}
            onChange={handleEmailNotificationsToggle}
            disabled={isTogglingNotifications}
          />
        </NotificationHeader>
        <NotificationDescription>
          This includes mentions, replies, comments, new challenges, and
          platform updates. You can change your preferences anytime.
        </NotificationDescription>
      </EmailNotificationsContainer>
      <CloseAccountContainter>
        <TextContainer>
          <Title>Close account</Title>
          <Paragraph>
            Once you delete your user, there is no going back. Please be
            certain.
          </Paragraph>
        </TextContainer>
        <CloseButton variant="danger" onClick={onDeleteAccount}>
          Close account
        </CloseButton>
      </CloseAccountContainter>
    </Container>
  );
};

export default ChangeAccount;
